import styled from 'styled-components'
import Row from 'components/Row'

export const ActionsSection = styled.div`
  margin-top: 24px;
`
export const LabelWrapper = styled.div`
  margin-bottom: 12px;
`
export const ActionsCard = styled.div`
  background: #fafafa;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0px 8px 16px rgba(32, 32, 32, 0.05);
`
export const SectionTitle = styled.h4`
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: #202020;
`
export const ColumnHeaders = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 44px;
  gap: 16px;
  font-size: 15px;
  color: #333333;
  span:last-child {
    text-align: center;
  }
  margin-top: 26px;
`
export const RowsWrapper = styled.div`
  margin-top: 12px;
  border-top: 1px solid rgba(32, 32, 32, 0.08);
`
export const ActionRow = styled.div`
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 44px;
  gap: 16px;
  align-items: center;
  padding: 8px 0 10px 0;
`

export const DividerLine = styled.div`
  height: 1px;
  background: rgba(32, 32, 32, 0.08);
`
export const PlaceholderCell = styled.div`
  height: 44px;
  border: 1px dashed rgba(32, 32, 32, 0.15);
  border-radius: 4px;
`
export const IconPlaceholder = styled.div`
  width: 44px;
  height: 44px;
`
export const AddButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
`
export const TopMarginDiv = styled.div`
  margin-top: 18px;
`
export const StyledRow = styled(Row)`
  margin-bottom: 35px;
`
